/**
 * ReferralInstructions component - explains how the referral system works
 */
import React from "react";
import { Box, Text, Title } from "@mantine/core";

export const ReferralInstructions: React.FC = () => {
  return (
    <Box>
      <Title order={5} mb="xs">
        How Referrals Work:
      </Title>
      <Box
        component="ul"
        style={{ marginTop: "8px", marginBottom: 0, paddingLeft: "20px" }}
      >
        <li>
          <Text size="sm" c="dimmed" component="span">
            Share your referral link with tax professionals
          </Text>
        </li>
        <li style={{ marginTop: "4px" }}>
          <Text size="sm" c="dimmed" component="span">
            They sign up and become a paying customer
          </Text>
        </li>
        <li style={{ marginTop: "4px" }}>
          <Text size="sm" c="dimmed" component="span">
            You both earn rewards when they subscribe!
          </Text>
        </li>
        <li style={{ marginTop: "4px" }}>
          <Text size="sm" c="dimmed" component="span">
            Installment payments: 25% upfront, 75% on completion
          </Text>
        </li>
      </Box>
    </Box>
  );
};
